import { useRegisterSW } from "virtual:pwa-register/react";
import { Button } from "@/components/ui/button.tsx";

function PWABadge() {
	// check for updates every hour
	// const period = 60 * 60 * 1000;

	// check for updates every 10 min
	const period = 10 * 60 * 1000;

	const {
		needRefresh: [needRefresh, setNeedRefresh],
		updateServiceWorker,
	} = useRegisterSW({
		onRegisteredSW(swUrl, r) {
			if (period <= 0) return;
			if (r?.active?.state === "activated") {
				registerPeriodicSync(period, swUrl, r);
			} else if (r?.installing) {
				r.installing.addEventListener("statechange", (e) => {
					const sw = e.target as ServiceWorker;
					if (sw.state === "activated")
						registerPeriodicSync(period, swUrl, r);
				});
			}
		},
	});

	function close() {
		setNeedRefresh(false);
	}

	return (
		<>
			{needRefresh && (
				<div className="fixed right-0 bottom-0 m-16 z-50 shadow-2xl rounded-xl bg-secondary/90 p-4">
					<div className="m-2 mb-6">
						<div id="toast-message" className={"text-xl mb-2"}>
							Update Available
						</div>
						<div>
							New Feature: List groups.
						</div>
						<div
							id="toast-message"
							className={"text-slate-500"}
						>
							Click on reload button to update.
						</div>
					</div>
					<div className="flex gap-2">
						<Button
							variant={"default"}
							onClick={() => updateServiceWorker(true)}
						>
							Reload
						</Button>
						<Button variant={"ghost"} onClick={() => close()}>
							Close
						</Button>
					</div>
				</div>
			)}
		</>
	);
}

export default PWABadge;

/**
 * This function will register a periodic sync check every hour, you can modify the interval as needed.
 */
function registerPeriodicSync(period: number, swUrl: string, r: ServiceWorkerRegistration) {
	if (period <= 0) return;

	const checkUpdate = async () => {
		if ("onLine" in navigator && !navigator.onLine) return;

		const resp = await fetch(swUrl, {
			cache: "no-store",
			headers: {
				cache: "no-store",
				"cache-control": "no-cache",
			},
		});

		if (resp?.status === 200) await r.update();
	};

	setInterval(checkUpdate, period);

	checkUpdate();
}
